import { api } from '../api.js';

/** 상태 표시 — ok·unknown은 따로 표시하지 않는다(서버가 준 health) */
export const HEALTH = { degraded: ['일부 장애', 'warn'], down: ['중단', 'crit'] };

/**
 * 서비스 열기(런처·홈 공통, 계획 문서 5.3 3c) — 새 창은 누른 순간 연다(팝업 차단을 피해), 최근 사용 기록은 서버에 남긴다(실패하면 알린다).
 * 잠긴 서비스는 열지 않는다(서버가 403 — 화면은 access로 단추를 막는다)
 */
export function openService(app, onToast) {
  if (!app.url) return;
  window.open(app.url, '_blank', 'noopener');
  api.post(`/api/v1/services/${encodeURIComponent(app.id)}/open`, {}).catch(e => onToast?.('최근 사용을 저장하지 못했습니다 — ' + e.message));
}
